module.exports = __webpack_public_path__ + "img/semi_parked.8122f5b4.svg";